import React from 'react';
import { Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';

const aboutSanitizeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), 'mark'],
  attributes: {
    ...defaultSchema.attributes,
    mark: [],
  },
};

function preprocessHighlights(text) {
  if (!text) return '';
  return text.replace(/==([^=\n]+)==/g, '<mark>$1</mark>');
}

/**
 * Renders card About copy with Markdown (**bold**, *italic*, lists, links) and ==highlight==.
 */
export function AboutFormattedText({
  text,
  variant = 'body2',
  component = 'div',
  sx = {},
  textAlign,
  markSx,
}) {
  const src = preprocessHighlights(text || '');
  const defaultMark = {
    backgroundColor: 'rgba(250, 204, 21, 0.38)',
    color: 'inherit',
    padding: '0 0.12em',
    borderRadius: '3px',
  };

  return (
    <Typography
      variant={variant}
      component={component}
      sx={{
        lineHeight: 1.7,
        wordBreak: 'break-word',
        '& p': { m: 0, mb: 1, '&:last-child': { mb: 0 } },
        '& ul, & ol': { m: 0, pl: 2.5, mb: 1, '&:last-child': { mb: 0 } },
        '& li': { mb: 0.25 },
        '& strong': { fontWeight: 700 },
        '& a': { color: 'inherit', textDecoration: 'underline' },
        '& mark': { ...defaultMark, ...markSx },
        ...sx,
        ...(textAlign != null ? { textAlign } : {}),
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, aboutSanitizeSchema]]}
      >
        {src}
      </ReactMarkdown>
    </Typography>
  );
}
